<template>
  <div>
    <!--
    <b-row>
      <b-col >

        <b-table 
            :items="items" 
            :fields = "fields"
            striped
            responsive
            small
          /> 
        </b-col>

      <b-col class="col-md-3">
        <div>
              <b>Motivo de terapia:</b> {{dataTerapia.motivoSolicitud || "No disponible"}}
        </div>
           
      </b-col>
      
       <b-col class="mt-1 col-md-2">
        <div
          v-if="dataTerapia.pacEdad < 18"
          >
          <label> <b> El paciente es menor de edad. Seleccione quien lo cuida: </b></label>
          <v-select
            id="cuidador"
            v-model="detallesHabPac.cuidador"
            :options="cuidadorOpts"
            label="text"
           
          />
      </div>
      </b-col> 
      
    </b-row> -->
  
<b-tabs class="mt-2" lazy >
  <!-- <b-tab title="Antecedentes Ginecobstétricos" v-if="dataTerapia.pacientesexo === 1">
    <b-card
          
        >
        

          <b-row>

            <b-col class="col-6">

              <b-row class="mt-1 d-flex align-items-center">
                <label class="col-4">Edad de Menarquia</label>
                <b-form-input
                  class="col-2"
                  type = "number" 
                  v-model="anteGineco.edadMenarquia" 
                />
              </b-row>


              <b-row class="mt-1 d-flex align-items-center">

                <label class="col-4">Ciclos Irregulares: {{ anteGineco.ciclosIrregulares }}</label>
                <b-input-group class="col-6 p-0">
                  <b-form-input
                    v-model="anteGineco.ciclosIrregulares"
                    type="range"
                    min="0"
                    max="10"
                  />
                </b-input-group>

              </b-row>


              <b-row class="mt-1 d-flex align-items-center">
                <label class="col-4">Edad inicio vida sexual</label>
                <b-form-input
                  class="col-2"
                  type = "number"
                  v-model="anteGineco.edadInicioSexual" 
                />
              </b-row>

              <b-row class="mt-1 d-flex align-items-center">
                <label class="col-4">Parejas sexuales:</label>

                <b-form-input
                  class="col-2"
                  type = "number"
                  v-model="anteGineco.parejasSexuales" 
                />
              </b-row>


              <b-row class="mt-1 d-flex align-items-center">
                <label class="col-4">Métodos anticonceptivos:</label>
                <v-select
                  class="col-6 p-0"
                  placeholder="Seleccione o ingrese una opcion"
                  v-model="anteGineco.metodosAnticonceptivos"
                  :options="anticonceptivosOpts"
                  :reduce="option => option"
                  label="text"
                  taggable
                  @input="newArray => anteGineco.metodosAnticonceptivos = onAddUniqueNewOpt(newArray)"
                />
              </b-row>
            </b-col>


            <b-col>
              <b-row class="d-flex align-items-center">
                <b-col class="col-3">
                  <label>Gestas:</label>
                  <b-form-input 
                    class=""
                    v-model="anteGineco.gestas"
                  />
                </b-col>

                <b-col class="col-3">
                  <label>Parto normal:</label>
                  <b-form-input v-model="anteGineco.partoNormal"/>
                </b-col>
                

                <b-col class="col-3">
                  <label>Cesarea:</label>
                  <b-form-input v-model="anteGineco.cesarea"/>
                </b-col>

              </b-row>

              <b-row class="mt-1"> 

                <b-col class="col-3">
                  <label>Abortos:</label>
                  <b-form-input v-model="anteGineco.abortos" type="number"/>
                </b-col>
    
                <b-col class="col-3">
                  <label>Hijos vivos:</label>
                  <b-form-input v-model="anteGineco.hijosVivos" type="number"/>
                </b-col>
                    

                <b-col class="col-5">
                  <label> Citologia cervical: </label>

                  <v-select
                    class="p-0"
                    placeholder="Seleccione o ingrese una opcion"
                    v-model="anteGineco.citologiaVaginal"
                    :options="citologiaOpts"
                    :reduce="option => option"
                    label="text"
                    taggable
                    @input="newArray => anteGineco.citologiaCervical = onAddUniqueNewOpt(newArray)"
                  />
                </b-col>
              </b-row>
            </b-col>
            

          </b-row>
        </b-card>
  </b-tab> -->
  <b-tab title="Valoracion antropometrica/Biompendancia" >
    <b-card class="mt-1" border-variant="light">
      <h5>Valoración antropométrica:</h5>

      <b-row>
        <b-col class="col-3 mt-1">
          <label>Perimetro Abdominal: </label>
          <b-form-input type="number" v-model="dataNutricional.valAntroBiomp.perimetroAbdominal"/>
        </b-col>
        
        <b-col class="col-3 mt-1">
          <label>% Grasa abdominal: </label>
          <b-form-input type="number" v-model="dataNutricional.valAntroBiomp.pGrasaAbdomen"></b-form-input>
        </b-col>

        <b-col class="col-3 mt-1">
          <label>Edad: </label>
          <b-form-input type="number" v-model="dataNutricional.valAntroBiomp.edad"/>
        </b-col>
        
        <b-col class="col-3 mt-1">
          <label>Talla: </label>
          <b-form-input type="number" v-model="dataNutricional.valAntroBiomp.talla"/>
        </b-col>

        <b-col class="col-3 mt-1">
          <label>Peso Inicial: </label>
          <b-form-input type="number" v-model="dataNutricional.valAntroBiomp.pesoInicial"/>
        </b-col>
      
        <b-col class="col-3 mt-1">
          <label>Peso Actual: </label>
          <b-form-input type="number" v-model="dataNutricional.valAntroBiomp.pesoActual"/>
        </b-col>

        <b-col class="col-3 mt-1">
          <label>IMC Inicial: </label>
          <b-form-input type="number" v-model="dataNutricional.valAntroBiomp.imcInicial"/>
        </b-col>
      
        <b-col class="col-3 mt-1">
          <label>IMC Actual: </label>
          <b-form-input type="number" v-model="dataNutricional.valAntroBiomp.imcActual"/>
        </b-col>
          
      </b-row>

     

      <b-row class="mt-1">
        <label class="col-12"> <b> BIOMPEDANCIA</b></label>

        <b-col class="col-2 mt-1">
          <label>Masa grasa inicial: </label>
          <b-form-input type="number" v-model="dataNutricional.valAntroBiomp.masaGrasaInicial"/>
        </b-col>

        <b-col class="col-2 mt-1">
          <label>Masa muscular inicial:</label>
          <b-form-input type="number" v-model="dataNutricional.valAntroBiomp.masaMuscularInicial"/>
        </b-col>

        <b-col class="col-2 mt-1">
          <label>Grasa visceral inicial:</label>
          <b-form-input type="number" v-model="dataNutricional.valAntroBiomp.grasaVisceralInicial"/>
        </b-col>

        <b-col class="col-2 mt-1">
          <label>Tasa Metabolica Basal:</label>
          <b-form-input type="number" v-model="dataNutricional.valAntroBiomp.tasaMetabolicaBasal"/>
        </b-col>

        <b-col class="col-2 mt-1">
          <label>Ba:</label>
          <b-form-input type="number" v-model="dataNutricional.valAntroBiomp.Ba"/>
        </b-col>
        
      </b-row>

      
    </b-card>
  </b-tab>
  <b-tab title="Habitos Paciente" active>
    <b-row class="mt-2">
        <b-col class="col-5">

          <label> Nivel de hidratación: (Vasos Agua/ Dia) </label>

          <b-input-group
            :append="`${dataNutricional.detallesHabPac.hidratacion}`"
            class="mt-0"
          >
            <b-form-input
              v-model="dataNutricional.detallesHabPac.hidratacion"
              type="range"
              min="0"
              max="20"
            />
          </b-input-group>
        </b-col>

        <b-col class="col-2">
          <label>Horas de sueno:</label>
          <b-form-input v-model="dataNutricional.detallesHabPac.horasSueno" type="number"/>
        </b-col>

        <b-col class="col">
          <label> Consume café: </label>
          <b-form-checkbox
           v-model="dataNutricional.detallesHabPac.consumeCafe"
            name="check-button"
            switch
          >
            {{ dataNutricional.detallesHabPac.consumeCafe ? "Si" : "No" }}
          </b-form-checkbox>
        </b-col>
      </b-row>

      <div class="mt-0">

        <b-row class="d-flex align-items-center"> 

          <b-col class="col-6">
            <b-row class="d-flex align-items-center">
              <label class="col-4"> Contextura Corporal: </label>

              <v-select
                class="col-6 p-0"
                placeholder="Seleccione o ingrese una opcion"
                 v-model="dataNutricional.detallesHabPac.contexturaCorporal"
                :options="contexturaCorporalOpts"
                :reduce="option => option"
                label="text"
                taggable
                @input="newArray => dataNutricional.detallesHabPac.contexturaCorporal = onAddUniqueNewOpt(newArray)"
              />

            </b-row>

            <b-row class=" mt-1 d-flex align-items-center">
              <label class="col-4"> Tipo de dieta: </label>

              <v-select
                class="col-6 p-0"
                placeholder="Seleccione o ingrese una opcion"
                v-model="dataNutricional.detallesHabPac.tipoDieta"
                :options="tipoDietaOpts"
                :reduce="option => option"
                label="text"
                taggable
                @input="newArray => dataNutricional.detallesHabPac.tipoDieta = onAddUniqueNewOpt(newArray)"
              />
            </b-row>

            <b-row class="mt-1 d-flex align-items-center">
              <label class="col-4"> Nivel de actividad física: </label>

              <v-select
                class="col-6 p-0"
                placeholder="Seleccione o ingrese una opcion"
                :options="nivelActividadOpts"
                v-model="dataNutricional.detallesHabPac.nivelActividad"
                :reduce="option => option"
                label="text"
                taggable
                @input="newArray => dataNutricional.detallesHabPac.nivelActividad = onAddUniqueNewOpt(newArray)"
              />

            </b-row>
          </b-col>
          
          <b-col class ="col-6 mt-1">
            <label><b> Ingesta Típica:</b> </label>

            <b-row class="d-flex align-items-center">
              <label class="col-3">Comidas al día: </label>  
              <b-form-input
                class="col-2"
                id="sb-inline" 
                 v-model="dataNutricional.detallesHabPac.numcomidas"
              />
            </b-row>

            <b-row class="mt-1 d-flex align-items-center">
              <label class="col-2">Desayuno: </label>
              <b-form-input  v-model="dataNutricional.detallesHabPac.desayuno" class="col"/>
            </b-row>

            <b-row class="mt-1 d-flex align-items-center">
              <label class="col-2">Almuerzo: </label>
              <b-form-input  v-model="dataNutricional.detallesHabPac.almuerzo" class="col"/>
            </b-row>

            <b-row class="mt-1 d-flex align-items-center">
              <label class="col-2">Cena: </label>
              <b-form-input   v-model="dataNutricional.detallesHabPac.cena"class="col"/>
            </b-row> 

            <b-row class="mt-1 d-flex align-items-center">
              <label class="col-2">Otro: </label>
              <b-form-input  v-model="dataNutricional.detallesHabPac.otro" class="col"/>
            </b-row>

          </b-col>  
            
        </b-row>
          
      </div>
  </b-tab>
  <b-tab title="Recomendaciones" active>
    <b-card style="margin:0;border:1px solid #c9c9c9;">

<div class="my-2">
  <label>Recomendaciones:</label>

  <v-select
    class="col-6 p-0"
    placeholder="Seleccione o ingrese una opcion"
    v-model="dataNutricional.recomendaciones.recomendacion"
    :options="recomendacionesOpts"
    :reduce="option => option"
    label="text"
    taggable
    @input="newArray => dataNutricional.recomendaciones.recomendacion = onAddUniqueNewOpt(newArray)"
  />
</div>

<div class="my-2">
  <label for="">Plan Nutricional:</label>
  <b-form-textarea
    v-model="dataNutricional.recomendaciones.planNutricional"
    placeholder="Describa el plan nutricional aquí..."
    rows="2"
    class="form-control"
  />

</div>

<div class="my-2">
  <label for="">Conclusion:</label>
  <b-form-textarea
    id="conclusion"
    v-model="dataNutricional.recomendaciones.conclusion"
    placeholder="Describa la conclusion aquí..."
    rows="2"
    class="form-control"
  />

</div>
</b-card>
  </b-tab>
  <!-- <b-tab title="Firma" >
    <b-card class="mt-2" style="border:1px solid #c9c9c9;">
      <label><b>Firma:</b></label>
      <b-form-textarea/>
    </b-card>
  </b-tab> -->
</b-tabs>
  </div>

</template>

<script>
import vSelect from "vue-select";
import { addUniqueNewOpt } from '@/shared/helpers';


export default {
  name: "NutricionalDetallesPaciente",

  
  props: {
    dataTerapia:{
      type: Object,
      required: false
    },
    dataForm:{
      required:false,
      default:null
    }
  },

  components: {
    vSelect
  },

  created() {

    this.clearData()
   
  },

 

  data() {
    return {
        dataNutricional: {
           recomendaciones : {
            recomendacion : null,
            planNutricional : null,
            conclusion : null
          },
           detallesHabPac : {
          cuidador : null,
          hidratacion : null,
          horasSueno : null,
          consumeCafe : null,
          numcomidas : null,
          desayuno : null,
          almuerzo : null,
          cena : null,
          otro: null,
          contexturaCorporal : null,
          tipoDieta : null,
          nivelActividad : null
        },
          valAntroBiomp : {
          perimetroAbdominal : null,
          pGrasaAbdomen : null,
          edad : null,
          talla : null,
          pesoInicial : null,
          pesoActual : null,
          imcInicial : null,
          imcActual : null,
          masaGrasaInicial : null,
          masaMuscularInicial : null,
          grasaVisceralInicial : null,
          tasaMetabolicaBasal : null,
          Ba: null
        },

        },
     
      
        anteGineco : {
            edadMenarquia : null,
            ciclosIrregulares : null,
            edadInicioSexual : null,
            parejasSexuales : null,
            metodosAnticonceptivos : [],
            gestas : null,
            partoNormal : null,
            cesarea: null,
            abortos:null,
            hijosVivos:null,
            citologiaVaginal:null
          },

      items : [{
        anteper : null,
        antefam : null,
        ocupacion : null,
      }],
      fields: [

                { key: 'anteper', label: 'Ante Personales', sortable: true, thClass: 'text-center' },
               
                { key: 'antefam', label: 'Ante Familiares', sortable: true, thClass: 'text-center' },
                { key: 'ocupacion', label: 'Ocupacion', sortable: true, thClass: 'text-center' },
                

            ],
      
      motivoterapia:null,
     
      contexturaCorporalOpts:[
        "Ectomorfo",
        "Mesomorfo",
        "Endomorfo",
        "Ectomesomorfo",
        "Endomesomorfo",
      ],

      tipoDietaOpts:[
        "Hiper calórica",
        "Hipo calórica",
        "Cetogénica",
        "Hiper grasa",
        "Vegano",
        "Vegetariano",
        "Hipo grasa",
      ],


      nivelActividadOpts:[
        "Sedentario",
        "Bajo",
        "Moderado",
        "Alto",
        "Muy alto"
      ],


      anticonceptivosOpts: [
        "Quirúrgico",
        "Píldoras",
        "Parches",
        "Inyecciones",
        "DIU",
        "Implante",
        "Condón",
        "Otro",
      ],


      cuidadorOpts: [
        "Papá",
        "Mamá",
        "Tío",
        "Tía",
        "Abuelo",
        "Abuela",
        "Primo",
        "Prima",
      ],


      citologiaOpts : [
        "No se ha realizado", 
        "Hace menos de 1 año", 
        "Hace 1 año", 
        "Hace 2 años", 
        "Hace 3 años", 
        "Hace 4 años", 
        "Hace 5 años", 
        "Hace más de 5 años"
      ],


      recomendacionesOpts: [
        { 
          text: "Hidratación", 
          value: "Hidratación" 
        },
        {
          text: "Disminuir ingesta de carbohidratos",
          value: "Disminuir ingesta de carbohidratos",
        },
        {
          text: "Aumentar actividad física",
          value: "Aumentar actividad física",
        },
        {
          text: "Inclusión de alimentos integrales",
          value: "Inclusión de alimentos integrales",
        },
        {
          text: "Aumento de consumo de proteínas",
          value: "Aumento de consumo de proteínas",
        },
        { 
          text: "Mejorar hábitos de sueño", 
          value: "Mejorar hábitos de sueño" 
        },
        { 
          text: "Otras recomendaciones", 
          value: "Otro" 
        },
      ],

    };
  },
  


  watch: {

   dataForm:{
    immediate:true,
    deep:true,
    handler(newValue){
      if(newValue){
        this.dataNutricional = newValue
      }else{
        this.clearData()
      }
    }
   },

   dataNutricional:{
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue){
          this.$emit('update-nutricional', newValue);
        }
        
      },
    },
   

  },
 


  methods: {

    clearData(){
       this.dataNutricional.recomendaciones =       {
           recomendaciones : {
            recomendacion : null,
            planNutricional : null,
            conclusion : null
          }
        }

        this.dataNutricional.detallesHabPac = {
          cuidador : null,
          hidratacion : null,
          horasSueno : null,
          consumeCafe : null,
          numcomidas : null,
          desayuno : null,
          almuerzo : null,
          cena : null,
          otro: null,
          contexturaCorporal : null,
          tipoDieta : null,
          nivelActividad : null
        }
        this.dataNutricional.valAntroBiomp = {
          perimetroAbdominal : null,
          pGrasaAbdomen : null,
          edad : null,
          talla : null,
          pesoInicial : null,
          pesoActual : null,
          imcInicial : null,
          imcActual : null,
          masaGrasaInicial : null,
          masaMuscularInicial : null,
          grasaVisceralInicial : null,
          tasaMetabolicaBasal : null,
          Ba: null
        }

        },
    
    loadDataTabla(){
      
      this.items[0].ocupacion =  this.dataTerapia.pacienteOcupacion ? this.dataTerapia.pacienteOcupacion : "No disponible"
      if(this.dataTerapia.antecedentesFamiliares.length > 0){
        let detallesantefam = []
        for(let i = 0; i < this.dataTerapia.antecedentesFamiliares.length; i++) {
          if(this.dataTerapia.antecedentesFamiliares[i].antescedentesFamiliares
          ) {
            detallesantefam.push(`${this.dataTerapia.antecedentesPersonales[i].antescedentesFamiliares} : ${this.dataTerapia.antecedentesPersonales[i].descripcionGeneral}`)

          }
          
        }
         detallesantefam = detallesantefam.join(', ')
        this.items[0].antefam = detallesantefam.length > 0 ? detallesantefam : 'No refiere'

      } else {
        this.items[0].antefam = 'No refiere'
      }
      if(this.dataTerapia.antecedentesPersonales.length > 0){
        let detallesanteper = []
        for(let i = 0; i < this.dataTerapia.antecedentesPersonales.length; i++) {
          if(this.dataTerapia.antecedentesPersonales[i].antescedentesPersonales
          ) {
           
            detallesanteper.push(`${this.dataTerapia.antecedentesPersonales[i].antescedentesPersonales} : ${this.dataTerapia.antecedentesPersonales[i].descripcionGeneral}`)
            
          }
          
        }
        detallesanteper = detallesanteper.join(', ')
        this.items[0].anteper = detallesanteper.length > 0 ? detallesanteper : 'No refiere'

      } else {
        this.items[0].anteper = 'No refiere'
      }
     
     
    }
     ,

    onAddUniqueNewOpt(newArray) {
      return addUniqueNewOpt(newArray);
    },

    actualizarStorageNutricion(newData){
      this.$store.commit("setTerapiaNutricional", { newData} );

    }
  }
}
</script>
